<template>
    <div class="content-widget container">
        <div class="content-widget-items d-lg-flex">
            <div class="content-widget-items-title">
                <h2 v-html="widget.title"></h2>
            </div>
            <div class="content-widget-items-description" v-if="widget.description">
                <p v-html=" widget.description"></p>
            </div>
            <button class="content-widget-items-btn" v-if="widget.url[0].url_externa_label">
                <a :href=" widget.url[0].url_externa_link">
                    <p v-if="widget.url[0].url_externa_label">{{ widget.url[0].url_externa_label }}</p>
                </a>
            </button>
        </div>
        <div class="content-widget-img">
            <img  class="img-fluid" :src="widget.image" alt="fruits">
        </div>
    </div>
</template>
<script>
export default {
    props: ['widget'],
}
</script>

<style lang="scss">
.container-widget:nth-child(odd){
    margin: 0;
    padding: 0;
    height: 460px;
    margin-bottom: 5rem;
    display: flex;
    justify-content: flex-end;
    position: relative;
    overflow: hidden;
    margin-bottom: 150px;
    @media screen and (max-width: 991px){
        height: auto;
        margin-bottom: 80px;
    }
    .content-widget{
        display: flex;
        width: 100%;
        margin-left: auto;
        height: 100%;
        justify-content: space-between;
        @media screen and (max-width: 991px){
            flex-direction: column-reverse;
            align-items: center;
            height: auto;
            gap: 50px;
            max-width: 100%;
            padding: 0!important;
        }
        &-items{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            text-align: left;
            justify-content: center;
            max-width: 60%;
            padding-right: 2rem;
            @media screen and (max-width: 1700px){
                max-width: 50%;
            }
            @media screen and (max-width: 1200px){
                max-width: 45%;
            }
            @media screen and (max-width: 991px){
                max-width: 720px;
                padding-right: 15px;
                padding-left: 15px;
                align-items: center!important;
            }
            @media screen and (max-width: 768px){
                max-width: 540px;
            }
            &-title{
                h2{
                    font-family: 'Font Bold', sans-serif;
                    font-size: 40px;
                    color: var( --green-medium);
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    margin-bottom: 30px;
                    @media screen and (max-width: 991px){
                        font-size: 28px;
                    }
                }
            }
            &-description{
                p{
                    font-family: 'Font Regular', sans-serif;
                    font-size: 28px;
                    color: #112D23;
                    text-align: left;
                    display: -webkit-box;
                    -webkit-line-clamp: 6;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    padding: 0;
                    margin: 0;
                    @media screen and (max-width: 991px){
                    font-size: 18px;
                    }
                }
                
            }
            &-btn{
                display: flex;
                align-items: center;
                justify-content: center;
                min-width: 160px;
                padding: 5px 10px;
                height: 60px;
                border-radius: 10px;
                margin-top: 2rem;
                border: none;
                background-color: var( --green-medium);
                box-shadow: 5px 5px 10px #00000016;
                &:hover, &:focus{
                    transition: all 0.5s ease;
                    filter: drop-shadow(0 0 10px var( --green-medium));
                }
                a{
                    font-family: 'Font Regular', sans-serif;
                    font-size: 22px;
                    color: #ffffff;
                    text-decoration: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    p{
                        margin: 0;
                    }
                }

            }
            
        }
        &-img{
            position: absolute;
            right: 0px;
            z-index: -1;
            @media screen and (max-width: 1500px){
                right: -5%;
            }
            @media screen and (max-width: 1400px){
                right: -10%;
            }
            @media screen and (max-width: 1300px){
                right: -15%;
            }
            @media screen and (max-width: 1150px){
                right: -20%;
            }
            @media screen and (max-width: 991px){
                position:relative;
                right: auto;
            }
            @media screen and (max-width: 991px){
                margin-top: 2rem;
                width: 100%;
            }
            img{
                width: 754px;
                height: 460px;
                border-radius: 20px 0 0 20px;
                object-fit: cover;
                object-position: center;
                @media screen and (max-width: 991px){
                    width: 100%!important;
                    max-width: 100%!important;
                    min-width: 100%!important;
                    height: 262px;
                    border-radius: 0!important;
                }
                
            }
        }
    }
}
.container-widget:nth-child(even){
    margin: 0;
    padding: 0;
    height: 460px;
    margin-bottom: 5rem;
    display: flex;
    justify-content: flex-end!important;
    position: relative;
    overflow: hidden;
    margin-bottom: 150px;
    @media screen and (max-width: 991px){
        height: auto;
        margin-bottom: 80px;
    }
    .content-widget{
        display: flex;
        width: 100%;
        margin-left: auto;
        height: 100%;
        justify-content: flex-end;
        @media screen and (max-width: 991px){
            flex-direction: column-reverse;
            align-items: center;
            height: auto;
            gap: 50px;
            max-width: 100%;
            padding: 0!important;
        }
        &-items{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            text-align: left;
            justify-content: center;
            max-width: 60%;
            padding-left: 2rem;
            @media screen and (max-width: 1700px){
                max-width: 50%;
            }
            @media screen and (max-width: 1200px){
                max-width: 45%;
            }
            @media screen and (max-width: 991px){
                max-width: 720px;
                padding-right: 15px;
                padding-left: 15px;
                align-items: center!important;
            }
            @media screen and (max-width: 768px){
                max-width: 540px;
            }
            &-title{
                h2{
                    font-family: 'Font Bold', sans-serif;
                    font-size: 40px;
                    color: var( --green-medium);
                    margin-bottom: 30px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    @media screen and (max-width: 991px){
                        font-size: 28px;
                    }
                }
            }
            &-description{
                p{
                    font-family: 'Font Regular', sans-serif;
                    font-size: 28px;
                    color: #112D23;
                    text-align: left;
                    display: -webkit-box;
                    -webkit-line-clamp: 6;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    padding: 0;
                    margin: 0;
                    @media screen and (max-width: 991px){
                    font-size: 18px;
                    }
                }
                
            }
            &-btn{
                display: flex;
                align-items: center;
                justify-content: center;
                min-width: 160px;
                padding: 5px 10px;
                height: 60px;
                border-radius: 10px;
                margin-top: 2rem;
                border: none;
                background-color: var( --green-medium);
                box-shadow: 5px 5px 10px #00000016;
                &:hover, &:focus{
                    transition: all 0.5s ease;
                    filter: drop-shadow(0 0 10px var( --green-medium));
                }
                a{
                    font-family: 'Font Regular', sans-serif;
                    font-size: 22px;
                    color: #ffffff;
                    text-decoration: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    p{
                        margin: 0;
                    }
                }

            }
            
        }
        &-img{
            position: absolute;
            left: 0px;
            z-index: -1;
            @media screen and (max-width: 1500px){
                left: -5%;
            }
            @media screen and (max-width: 1400px){
                left: -10%;
            }
            @media screen and (max-width: 1300px){
                left: -15%;
            }
            @media screen and (max-width: 1150px){
                left: -20%;
            }
            @media screen and (max-width: 991px){
                position:relative;
                left: auto;
            }
            @media screen and (max-width: 991px){
                margin-top: 2rem;
                width: 100%;
            }
            img{
                width: 754px;
                height: 460px;
                border-radius: 0 20px 20px 0;
                object-fit: cover;
                object-position: center;
                @media screen and (max-width: 991px){
                    width: 100%;
                    max-width: 100%;
                    min-width: 100%;
                    height: 262px;
                    border-radius: 0!important;
                }
                
            }
        }
    }
}


</style>